import {
  PencilIcon,
  UserIcon,
  WalletIcon,
  LockClosedIcon,
  BellIcon,
  DocumentIcon,
  DocumentTextIcon,
  WrenchIcon,
  ChevronUpDownIcon,
  CheckIcon,
  ArrowPathIcon,
  XCircleIcon,
  XMarkIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  EyeSlashIcon,
  EyeIcon,
  MagnifyingGlassIcon,
  HomeIcon,
  ChartBarIcon,
  BanknotesIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowLeftIcon,
  ShareIcon,
  MapPinIcon,
  PhotoIcon,
  MapIcon,
  UsersIcon,
  ChartPieIcon,
  RectangleGroupIcon,
  WrenchScrewdriverIcon,
  ArrowsPointingOutIcon,
  ArrowsUpDownIcon,
  CubeTransparentIcon,
  LightBulbIcon,
  SparklesIcon,
  MoonIcon,
  QueueListIcon,
  TruckIcon,
  LifebuoyIcon,
  BarsArrowUpIcon,
  Bars3Icon,
  UserMinusIcon,
  UserPlusIcon,
  Squares2X2Icon,
  BuildingStorefrontIcon,
  ReceiptPercentIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
  GlobeAltIcon,
  CurrencyEuroIcon,
  CurrencyDollarIcon,
  EllipsisHorizontalCircleIcon,
  ChevronUpIcon,
  ArrowPathRoundedSquareIcon,
  ArrowRightIcon,
  PencilSquareIcon,
  PlusCircleIcon,
  TrashIcon,
  ArchiveBoxIcon,
  BookOpenIcon,
  BookmarkSquareIcon,
  ChatBubbleBottomCenterIcon,
  CreditCardIcon,
  InformationCircleIcon,
  ShieldCheckIcon,
  KeyIcon,
  ExclamationTriangleIcon,
  ArrowDownOnSquareIcon,
  PlusIcon,
  BuildingOffice2Icon,
  DevicePhoneMobileIcon,
  ComputerDesktopIcon,
  DeviceTabletIcon,
  ExclamationCircleIcon,
  ArrowRightCircleIcon,
  NewspaperIcon,
  LinkIcon,
  FaceFrownIcon,
  UserGroupIcon,
  RocketLaunchIcon,
  ClockIcon,
  PhoneIcon,
  ClipboardDocumentIcon,
  ShoppingCartIcon,
  IdentificationIcon,
  CalendarIcon,
  MinusIcon,
  ArrowUpOnSquareIcon,
  FingerPrintIcon,
  EnvelopeIcon,
  CursorArrowRaysIcon,
  CheckBadgeIcon,
  PaperAirplaneIcon,
} from '@heroicons/react/20/solid'

export const HeroIcons = {
  PaperAirplaneIcon,
  CheckBadgeIcon,
  CursorArrowRaysIcon,
  ArrowUpOnSquareIcon,
  MinusIcon,
  CalendarIcon,
  PencilIcon,
  UserIcon,
  WalletIcon,
  LockClosedIcon,
  BellIcon,
  DocumentIcon,
  DocumentTextIcon,
  WrenchIcon,
  ChevronUpDownIcon,
  CheckIcon,
  ArrowPathIcon,
  XCircleIcon,
  XMarkIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  EyeSlashIcon,
  EyeIcon,
  MagnifyingGlassIcon,
  HomeIcon,
  ChartBarIcon,
  BanknotesIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowLeftIcon,
  ShareIcon,
  MapPinIcon,
  PhotoIcon,
  MapIcon,
  UsersIcon,
  ChartPieIcon,
  RectangleGroupIcon,
  WrenchScrewdriverIcon,
  ArrowsPointingOutIcon,
  ArrowsUpDownIcon,
  CubeTransparentIcon,
  LightBulbIcon,
  SparklesIcon,
  MoonIcon,
  QueueListIcon,
  TruckIcon,
  LifebuoyIcon,
  BarsArrowUpIcon,
  Bars3Icon,
  UserMinusIcon,
  UserPlusIcon,
  Squares2X2Icon,
  BuildingStorefrontIcon,
  ReceiptPercentIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon,
  GlobeAltIcon,
  CurrencyEuroIcon,
  CurrencyDollarIcon,
  EllipsisHorizontalCircleIcon,
  ChevronUpIcon,
  ArrowPathRoundedSquareIcon,
  ArrowRightIcon,
  PencilSquareIcon,
  PlusCircleIcon,
  TrashIcon,
  ArchiveBoxIcon,
  BookOpenIcon,
  BookmarkSquareIcon,
  ChatBubbleBottomCenterIcon,
  CreditCardIcon,
  InformationCircleIcon,
  ShieldCheckIcon,
  KeyIcon,
  ExclamationTriangleIcon,
  ArrowDownOnSquareIcon,
  PlusIcon,
  BuildingOffice2Icon,
  DevicePhoneMobileIcon,
  ComputerDesktopIcon,
  DeviceTabletIcon,
  ExclamationCircleIcon,
  ArrowRightCircleIcon,
  NewspaperIcon,
  LinkIcon,
  FaceFrownIcon,
  UserGroupIcon,
  RocketLaunchIcon,
  ClockIcon,
  PhoneIcon,
  ClipboardDocumentIcon,
  ShoppingCartIcon,
  IdentificationIcon,
  FingerPrintIcon,
  EnvelopeIcon,
}
